/**
 * 마크업 문자열에서 alt 속성이 없는 img 엘리먼트에 alt 값을 추가하는 함수
 */
export const addAltToImages = (content: string, altText: string): string => {
  const imgRegex = /<img(?![^>]*alt\s*=)[^>]*>/gi;

  return content.replaceAll(imgRegex, (match) => {
    if (match.endsWith('/>')) {
      return match.slice(0, -2) + ` alt="${altText}" />`;
    }

    return match.slice(0, -1) + ` alt="${altText}">`;
  });
};
